import Image from "next/image";
import { FC } from "react";

interface BFLImageProps {
  alt: string;
  src: string;
  width?: number;
  height?: number;
  priority?: boolean;
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
  unoptimized?: boolean;
  quality?: number;
  className?: string;
  fill?: boolean;
}

const BFLImage: FC<BFLImageProps> = ({
  alt = "",
  src,
  width,
  height,
  loading = "lazy",
  unoptimized = false,
  quality = 100,
  priority = false,
  fetchPriority,
  className,
  fill = false,
}) => {
  if (!src) {
    return;
  }
  return (
    <Image
      src={src}
      alt={alt}
      quality={quality}
      {...(priority && { priority })}
      {...(fetchPriority && { fetchPriority })}
      {...(unoptimized && { unoptimized })}
      {...(width && { width })}
      {...(height && { height })}
      {...(fill && { fill })}
      {...(className && { className })}
    />
  );
};

export default BFLImage;
